import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-skill-category-social",
  "use": "icon-skill-category-social-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-skill-category-social\">\r\n  <path d=\"M4 10.5v3a2 2 0 0 0 2 2h3l8 4.5V4l-8 4.5H6a2 2 0 0 0-2 2Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\r\n  <path d=\"M9 15.5 10.5 21H7l-1.5-5.5M20 8.5a5.2 5.2 0 0 1 0 7\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol